/**
 * Admin category management API calls.
 */
import api from "@/utils/axios";

export type UpdateCategoryPayload = {
  nameDe: string;
  nameEn: string;
};

export const updateCategory = async (
  slug: string,
  payload: UpdateCategoryPayload
) => {
  const response = await api.put(
    `/admin/categories/${encodeURIComponent(slug)}`,
    payload,
    { validateStatus: () => true }
  );
  return response;
};

export const deleteCategory = async (slug: string) => {
  return api.delete(`/admin/categories/${encodeURIComponent(slug)}`, {
    validateStatus: () => true,
  });
};

export type CreateCategoryPayload = {
  nameDe: string;
  nameEn: string;
  parentSlug?: string | null;
};

export const createCategory = async (payload: CreateCategoryPayload) => {
  return api.post("/admin/categories", payload, {
    validateStatus: () => true,
  });
};

export type MoveCategoryWebsitesPayload = {
  targetCategoryId: string;
};

export const moveCategoryWebsites = async (
  slug: string,
  payload: MoveCategoryWebsitesPayload
) => {
  return api.post(
    `/admin/categories/${encodeURIComponent(slug)}/move-websites`,
    payload,
    { validateStatus: () => true }
  );
};
